/* @ngInject */

export default () => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function FundingWorksheetFundsAvailableSplit(
    id,
    idSecurity,
    proposedLoanAmount,
    totalProposedLoanAmount,
    firstHomeOwnersGrant,
    isEditFirstHomeOwnersGrant,
    saleProceedFunds,
    savings,
    depositPaid,
    equityFromProperty,
    gift,
    otherFundsAvailable,
    baseLvr,
    totalLvr,
    originalLmi,
    lmi,
    isEditLmi,
    isCapitalize,
    idLender,
    isCrossCollateralized
  ) {
    this.id = id;
    this.idSecurity = idSecurity;
    this.proposedLoanAmount = proposedLoanAmount;
    this.totalProposedLoanAmount = totalProposedLoanAmount;
    this.firstHomeOwnersGrant = firstHomeOwnersGrant;
    this.isEditFirstHomeOwnersGrant = isEditFirstHomeOwnersGrant;
    this.saleProceedFunds = saleProceedFunds;
    this.savings = savings;
    this.depositPaid = depositPaid;
    this.equityFromProperty = equityFromProperty;
    this.gift = gift;
    this.otherFundsAvailable = otherFundsAvailable;
    this.baseLvr = baseLvr;
    this.totalLvr = totalLvr;
    this.originalLmi = originalLmi;
    this.lmi = lmi;
    this.isEditLmi = isEditLmi;
    this.isCapitalize = isCapitalize;
    this.idLender = idLender;
    this.isCrossCollateralized = isCrossCollateralized;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  FundingWorksheetFundsAvailableSplit.Blank = function () {
    return FundingWorksheetFundsAvailableSplit.Build({
      id: _.uuid(),
      idSecurity: '',
      proposedLoanAmount: 0,
      totalProposedLoanAmount: 0,
      firstHomeOwnersGrant: 0,
      isEditFirstHomeOwnersGrant: false,
      saleProceedFunds: 0,
      savings: 0,
      depositPaid: 0,
      equityFromProperty: 0,
      gift: 0,
      otherFundsAvailable: 0,
      baseLvr: 0,
      totalLvr: 0,
      originalLmi: 0,
      lmi: 0,
      isEditLmi: false,
      isCapitalize: false,
      idLender: '',
      isCrossCollateralized: false
    });
  };
  FundingWorksheetFundsAvailableSplit.Build = function (data) {
    return new FundingWorksheetFundsAvailableSplit(
      data.id ? data.id : _.uuid(),
      data.idSecurity ? data.idSecurity : '',
      data.proposedLoanAmount ? data.proposedLoanAmount : 0,
      data.totalProposedLoanAmount ? data.totalProposedLoanAmount : 0,
      data.firstHomeOwnersGrant ? data.firstHomeOwnersGrant : 0,
      data.isEditFirstHomeOwnersGrant ? data.isEditFirstHomeOwnersGrant : false,
      data.saleProceedFunds ? data.saleProceedFunds : 0,
      data.savings ? data.savings : 0,
      data.depositPaid ? data.depositPaid : 0,
      data.equityFromProperty ? data.equityFromProperty : 0,
      data.gift ? data.gift : 0,
      data.otherFundsAvailable ? data.otherFundsAvailable : 0,
      data.baseLvr ? data.baseLvr : 0,
      data.totalLvr ? data.totalLvr : 0,
      data.originalLmi ? data.originalLmi : 0,
      data.lmi ? data.lmi : 0,
      data.isEditLmi ? data.isEditLmi : false,
      data.isCapitalize ? data.isCapitalize : false,
      data.idLender ? data.idLender : '',
      data.isCrossCollateralized ? data.isCrossCollateralized : false
    );
  };

  return FundingWorksheetFundsAvailableSplit;
};
